import React from 'react';
import {
  Box,
  Button,
  Card,
  Chip,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import { Goal } from '../mockStats';

interface GoalsCardProps {
  goals: Goal[];
}

const periodLabel: Record<Goal['period'], string> = {
  DAILY: 'щодня',
  WEEKLY: 'на тиждень',
  MONTHLY: 'на місяць',
};

const GoalsCard: React.FC<GoalsCardProps> = ({ goals }) => (
  <Card sx={{ height: '100%' }}>
    <Stack spacing={2.5} sx={{ height: '100%' }}>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Box>
          <Typography variant={'h3'}>{'Цілі'}</Typography>
          <Typography color={'text.secondary'} variant={'body2'}>
            {'Що ти обрав для себе як орієнтир.'}
          </Typography>
        </Box>
        <Button startIcon={<AddIcon />} size={'small'}>
          {'Додати'}
        </Button>
      </Stack>

      <Stack spacing={2}>
        {goals.map((g) => (
          <GoalRow key={g.id} goal={g} />
        ))}
      </Stack>
    </Stack>
  </Card>
);

const GoalRow: React.FC<{ goal: Goal }> = ({ goal }) => {
  const pct = Math.min(100, Math.round((goal.current / goal.target) * 100));
  const done = goal.current >= goal.target;
  return (
    <Box>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        sx={{ mb: 0.75 }}
      >
        <Stack direction={'row'} alignItems={'center'} spacing={1}>
          <FlagOutlinedIcon sx={{ color: 'primary.main', fontSize: 18 }} />
          <Typography fontWeight={600}>{goal.title}</Typography>
        </Stack>
        <Chip
          label={periodLabel[goal.period]}
          size={'small'}
          sx={{
            bgcolor: 'primary.purple',
            color: 'primary.main',
            fontWeight: 700,
            height: 22,
          }}
        />
      </Stack>
      <LinearProgress
        value={pct}
        variant={'determinate'}
        sx={{
          bgcolor: 'primary.vocabularyUnlearned',
          borderRadius: 10,
          height: 8,
          '& .MuiLinearProgress-bar': {
            bgcolor: done ? 'primary.aqua' : 'primary.main',
          },
        }}
      />
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        sx={{ mt: 0.5 }}
      >
        <Typography variant={'caption'} color={'text.secondary'}>
          {`${goal.current} з ${goal.target} ${goal.unit}`}
        </Typography>
        <Typography
          variant={'caption'}
          sx={{
            color: done ? 'primary.aqua' : 'primary.main',
            fontWeight: 700,
          }}
        >
          {`${pct}%`}
        </Typography>
      </Stack>
    </Box>
  );
};

export default GoalsCard;
